/* Pass a Layout and Widgets to this Component to Render a Dashboard */
import React, { useContext, forwardRef, useImperativeHandle } from "react";

import { Button, Spinner } from "@chakra-ui/react";
import { Breadcrumb, Title } from "../../Components/Atoms";
import { DatePicker } from "../../Components/Molecules";

import { StoreContext } from "../../Library/contexts";
import "./styles.css";

const Report = forwardRef(({ breadcrumb, title, isLoading, onApply, children }, ref) => {
  const { filters, constants } = useContext(StoreContext);

  const handleApply = () => {
    if (onApply) onApply(filters, constants);
  };

  useImperativeHandle(ref, () => {
    return {
      apply: handleApply,
    };
  });

  return (
    <div className="panel-main">
      <header className="panel-report-header">
        <Breadcrumb paths={breadcrumb} />
        <div style={{ width: 55 }} />
        <DatePicker />
        <Button className="panel-button" onClick={handleApply}>Apply</Button>
      </header>

      <main className="panel-report-container">
        <div className="panel-report-card">
          {title ? <Title>{title}</Title> : null}

          {isLoading ? (
            <div className="panel-spinner-holder"> <Spinner /> </div>
          ) : (children)}
        </div>
      </main>
    </div>
  );
});

export default Report;